import PropTypes from "prop-types";
import React, { useState } from "react";

import { Button, RadioButton, Text } from "@swa-ui/core";
import i18n from "@swa-ui/locale";

import styles from "./CompanySelection.module.scss";

/**
 * CompanySelection shows a list of company names and IDs and allows selection of one
 */
export const CompanySelection = (props) => {
  const { companies, onSelect } = props;
  const [selectedCompany, setSelectedCompany] = useState();

  return (
    <>
      <Text className={styles.header}>{i18n("CompanySelection__SELECT_COMPANY_LABEL")}</Text>
      <RadioButton {...getRadioButtonProps()} />
      <Button {...getButtonProps()}>{i18n("CompanySelection__SAVE_BUTTON")}</Button>
    </>
  );

  function getButtonProps() {
    return {
      className: styles.saveButton,
      disabled: !selectedCompany,
      fullWidth: true,
      onClick: onSaveClick,
    };
  }

  function getCompanyNameTextProps() {
    return {
      bold: true,
      className: styles.companyNameText,
      color: "company-select-dialog-option-text",
      size: "xlarge",
    };
  }

  function getRadioButtonProps() {
    return {
      ariaLiveInput: (name, index, length) =>
        `${i18n("CompanySelection__RADIO_BUTTON_ARIA_LIVE", {
          name,
          index,
          length,
        })}`,
      direction: "column",
      name: "companySelect",
      onChange: setSelectedCompany,
      radioButtonInfoList: companies?.map((company) => ({
        caption: <Text color="company-select-dialog-option-text">{company.companyId}</Text>,
        label: <Text {...getCompanyNameTextProps()}>{company.companyName}</Text>,
        value: company.companyId,
      })),
    };
  }

  function onSaveClick() {
    onSelect?.(selectedCompany);
    setSelectedCompany(null);
  }
};

CompanySelection.propTypes = {
  /** List of available companies */
  companies: PropTypes.arrayOf(
    PropTypes.shape({
      companyId: PropTypes.string,
      companyName: PropTypes.string,
    })
  ),

  /** Function called on clicking the save button */
  onSelect: PropTypes.func,
};
